import { Store } from '@ngrx/store';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { HypotheticalsDropdownOption } from 'HypotheticalsApp/enums/hypotheticals-common.enum';
import { ContentItemBase } from 'FoldersApp/directives/content-item-base.directive';
import { getSharingButtonConfig } from 'SharingApp/ts/utils/public-sharing-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class HypotheticalsFolderableListItemBaseDirective extends ContentItemBase {
    constructor(store) {
        super();
        this.store = store;
        this.showFileDropdown = true;
    }
    get itemSelectionEnabled() {
        return this.hypothetical.permissions.canView;
    }
    get relativePositionedElemId() {
        return `list-item-dropdown-${this.folderable.resourceType}-${this.folderable.item.id}`;
    }
    get fileDropdownConfig() {
        const shareOption = {
            type: 'option',
            label: 'Share',
            value: HypotheticalsDropdownOption.SHARE,
            icon: 'icon-share',
            disabled: !this.hypothetical.permissions?.canShare,
        };
        const { label, disabled } = getSharingButtonConfig(shareOption, this.hypothetical, this.hypothetical.permissions?.canShare);
        shareOption.label = label;
        shareOption.disabled = disabled;
        return {
            title: {
                label: '',
                icon: 'icon-dots-more',
            },
            list: [
                shareOption,
                {
                    type: 'option',
                    label: 'Rename',
                    value: HypotheticalsDropdownOption.RENAME,
                    icon: 'icon-edit',
                    disabled: !this.hypothetical.permissions?.canRename,
                },
                {
                    type: 'option',
                    label: 'Move',
                    value: HypotheticalsDropdownOption.MOVE,
                    icon: 'icon-folder-move',
                    disabled: !this.hypothetical.permissions?.canMove,
                },
                {
                    type: 'option',
                    label: 'Delete',
                    value: HypotheticalsDropdownOption.DELETE,
                    icon: 'icon-delete',
                    disabled: !this.hypothetical.permissions?.canDelete,
                },
            ],
        };
    }
    get hypothetical() {
        return this.folderable.item;
    }
    fileDropdownHandler(operationName) {
        switch (operationName) {
            case HypotheticalsDropdownOption.SHARE:
            case HypotheticalsDropdownOption.RENAME:
            case HypotheticalsDropdownOption.MOVE:
            case HypotheticalsDropdownOption.DELETE:
                const selectedFolderableItem = {
                    id: this.hypothetical.id,
                    name: this.hypothetical.name,
                    // The name of the backend Model
                    itemType: this.folderable.resourceType,
                    // A human-readable description of the item type
                    itemTypeDescription: this.folderable.resourceTypeDescription,
                    ancestorFolderId: this.ancestorInfo.id,
                    sharing: this.hypothetical.sharing,
                    relativePositionedElemId: this.relativePositionedElemId,
                };
                this.store.dispatch(setSelectedFolderableOperation({
                    selectedOperation: {
                        item: selectedFolderableItem,
                        operation: operationName,
                    },
                }));
                break;
            default:
                throw new Error(`Unknown operation ${operationName}`);
        }
    }
}
HypotheticalsFolderableListItemBaseDirective.ɵfac = function HypotheticalsFolderableListItemBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsFolderableListItemBaseDirective)(i0.ɵɵdirectiveInject(i1.Store)); };
HypotheticalsFolderableListItemBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: HypotheticalsFolderableListItemBaseDirective, features: [i0.ɵɵInheritDefinitionFeature] });
